<template>
  <div class="card shadow">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'distributors' }">Distributors</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Distributor
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body" v-loading="loading">
      <distributor-item-detail v-if="distributor" :distributor="distributor" />
    </div>
  </div>
</template>

<script>
import DistributorItemDetail from '@/components/Distributor/Item/DistributorItemDetail'

export default {
  components: {
    DistributorItemDetail,
  },

  data() {
    return {
      loading: false,
      activePane: 'details',
      distributor: null,
    }
  },

  async mounted() {
    this.loading = true

    try {
      var { data } = await this.$http.get(`/distributors/${ this.$route.params.id }`)
    } catch(err) {
      this.$message.error(err.response.data.message)
      return false
    } finally {
      this.loading = false
    }

    this.distributor = data
  },
  methods: {
    tabChange(tab, event) {
      this.activePane = tab.name
    },
  }
}
</script>
